// @flow

import urlToKey from './urlToKey';

export type Provider = {
  count: (path: string, tags: string[]) => any,
  timing: (path: string, duration: number, tags: string[]) => any,
  gauge: (path: string, value: number, tags: string[]) => any,
  sendPagePerformance: (tags: string[]) => any
}

let provider: Provider = {
  count: (path, tags) => console.log(path, tags),
  timing: (path, duration, tags) => console.log(path, duration, tags),
  gauge: (path, value, tags) => console.log(path, value, tags),
  sendPagePerformance: tags => console.log(tags)
};

export const DISABLED_PROVIDER: Provider = {
  count: () => { },
  timing: () => { },
  gauge: () => { },
  sendPagePerformance: () => { }
};

export type Store = { use: (provider: Provider) => void } & Provider;

const metrics: Store = {
  use: (metricsProvider: Provider) => {
    provider = metricsProvider;
  },
  count: (path, tags) => provider.count(path, tags),
  timing: (path, duration, tags) => provider.timing(path, duration, tags),
  gauge: (path, value, tags) => provider.gauge(path, value, tags),
  sendPagePerformance: (tags) => provider.sendPagePerformance(tags)
};

export default metrics;

export {
  urlToKey
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/metrics/index.js
 **/